export { default as IsDesktop } from "./IsDesktop";
export { default as IsPad } from "./IsPad";
export { default as IsMobile } from "./IsMobile";
export { default as IsNotMobile } from "./IsNotMobile";